var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.ConfirmOpen()}}},[_vm._v("重置任务工时记录")])
}
var staticRenderFns = []

export { render, staticRenderFns }